import { useLocation } from 'react-router';

import { useAppSelector } from 'dux/app/hooks';

import { theme } from '@prose-ui';

import { getRootToastData } from 'dux/user/selectors';

import { BasicToast } from './BasicToast';
import ToastPortal from './ToastPortal';

export const RootToast = () => {
  const toast = useAppSelector(getRootToastData);
  const {
    shouldDisplayToast = false,
    content = null,
    style = null,
    isPermanent = false,
  } = toast || {};

  const { pathname } = useLocation();

  const invalidUrl = pathname.includes('/redeem/invalid-code');

  const defaultStyle = { color: 'neutral.900', backgroundColor: theme.colors.tertiary[200] };
  const toastStyle = style || defaultStyle;

  return (
    !invalidUrl && (
      <ToastPortal>
        <BasicToast
          bgcolor={toastStyle.backgroundColor}
          dataTestId="root-toast-banner"
          isFullWidth
          isPermanent={isPermanent}
          shouldDisplayToast={shouldDisplayToast}
          textColor={toastStyle.color}
          toastType="root"
        >
          {content}{' '}
        </BasicToast>
      </ToastPortal>
    )
  );
};
